import { useMutation, useQueryClient } from '@tanstack/react-query'

import { identityServices } from '../identityServices'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useIdentityVerification = () => {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: identityServices.identityVerification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_ME],
      })
    },
  })
  return {
    ...mutation,
  }
}
